export default __webpack_public_path__ + "static/media/PortoHolding-RGB-H.5b8d5d69.png";